export const STORE_ROLES = {
  SUPERADMIN: 'superadmin',
  OWNER: 'owner',
  COOWNER: 'coowner',
  MANAGER: 'manager', 
  STAFF: 'staff',
} as const;

export const STORE_ROLE_LABELS = {
  [STORE_ROLES.SUPERADMIN]: 'Super Admin',
  [STORE_ROLES.OWNER]: 'Owner',
  [STORE_ROLES.COOWNER]: 'Co-Owner',
  [STORE_ROLES.MANAGER]: 'Manager',
  [STORE_ROLES.STAFF]: 'Staff',
} as const;

export const STORE_ROLE_OPTIONS = [
  { value: STORE_ROLES.COOWNER, label: STORE_ROLE_LABELS[STORE_ROLES.COOWNER] },
  { value: STORE_ROLES.MANAGER, label: STORE_ROLE_LABELS[STORE_ROLES.MANAGER] },
  { value: STORE_ROLES.STAFF, label: STORE_ROLE_LABELS[STORE_ROLES.STAFF] },
] as const;

export const VALID_STORE_ROLES = Object.values(STORE_ROLES);

export type StoreRole = typeof STORE_ROLES[keyof typeof STORE_ROLES]; 